'use client';

import SectionCard from '@/app/(website)/components/SectionCard';
import SectionHeader from '@/app/(website)/components/SectionHeader';
import CheckCircle from '@/assets/icons/CheckCircle.svg';
import Clock from '@/assets/icons/Clock.svg';
import Flash from '@/assets/icons/Flash.svg';
import Rocket from '@/assets/icons/Rocket.svg';
import { Body } from '@/components/body';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';

export default function HighlightsCommercialisti() {
  const [isVisible, setIsVisible] = useState(false);
  const gridRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.2,
      },
    );

    if (gridRef.current) {
      observer.observe(gridRef.current);
    }

    return () => {
      if (gridRef.current) {
        observer.unobserve(gridRef.current);
      }
    };
  }, []);

  return (
    <div
      id="highlights"
      className="flex flex-col items-center gap-10 py-16 px-8"
    >
      <SectionHeader
        badgeText="Funzionalità"
        title={
          <>
            Risparmia tempo,{' '}
            <span className="rounded-[2rem] rounded-br-[8px] py-0 px-2 md:px-4 bg-secondary text-primary">
              aumenta
            </span>{' '}
            l'efficienza
          </>
        }
        subtitle="Con Normo.ai, ottieni risposte accurate ai tuoi quesiti e supporto nell'analisi, redazione e revisione di documenti"
      />
      <div
        className="grid grid-cols-1 md:grid-cols-2 max-w-[56.625rem] gap-8"
        ref={gridRef}
      >
        <SectionCard
          text="Ottieni risposte articolate con tutti i riferimenti normativi, giurisprudenziali e di prassi."
          title="Risposte Accurate"
          icon={<Flash width={64} height={64} />}
          className={`transition-all duration-1000 ease-in-out transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
          }`}
        />
        <SectionCard
          text="Resta sempre aggiornato con la normativa, la prassi e la giurisprudenza. Normo.ai si aggiorna ogni notte."
          title="Fonti Aggiornate Quotidianamente"
          icon={<Clock width={64} height={64} />}
          className={`transition-all duration-1000 ease-in-out transform delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
          }`}
        />
        <SectionCard
          text="Dalla creazione di atti, pareri e memorie fino all’analisi di bilancio e revisioni contrattuali."
          title="Analizza, elabora e revisiona Documenti Complessi"
          icon={<CheckCircle width={64} height={64} />}
          className={`transition-all duration-1000 ease-in-out transform delay-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
          }`}
        />
        <SectionCard
          text="Normo.ai non è strutturato per moduli tematici, ma trasversale all’intero patrimonio normativo e giurisprudenziale."
          title="Nessun Limite di Moduli Fonti"
          icon={<Rocket width={64} height={64} />}
          className={`transition-all duration-1000 ease-in-out transform delay-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
          }`}
        />
      </div>
      <div
        className={cn(
          'flex flex-col items-center md:flex-row md:items-start gap-4 max-w-[912px] transition-all duration-1000 ease-in-out transform delay-1000',
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40',
        )}
      >
        <Image
          src="/ec.png"
          alt="Certificazion Euroconference"
          width={100}
          height={100}
        />
        <div className="flex flex-col">
          <Body variant="small">Certificazione Autorale Euroconference</Body>
          <Body variant="small" className="font-normal">
            Il modello di intelligenza artificiale generativa di Normo.ai è
            sottoposto ad un processo continuo di verifica e validazione da
            parte di un Comitato di Esperti Euroconference che contribuisce a
            valutarne la correttezza, la completezza e il rigore dei contenuti.
            Tale processo di controllo qualità ha l’obiettivo di offrire ai
            professionisti elaborati qualificati, attendibili e coerenti con
            l’evoluzione normativa, fermo restando il necessario giudizio
            critico del professionista.
          </Body>
        </div>
      </div>
    </div>
  );
}
